import * as React from 'react';
const CurrentDebtRow = ({ value, formatDate, formatNumber, }) => (React.createElement("div", { className: "ReadReport__Table__Row" },
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, value.currentDebt.numberOfAJudgments)),
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, formatNumber(value.currentDebt.amountInAJudgments))),
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, value.currentDebt.numberOfEJudgments)),
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, formatNumber(value.currentDebt.amountInEJudgments))),
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, formatDate(value.currentDebt.date, { year: 'numeric', month: 'numeric', day: 'numeric' })))));
export default CurrentDebtRow;
